<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center ion-align-items-center m-2 !flex h-full justify-center text-base">
        <div
            class="flex-column flex h-auto w-full max-w-sm rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="p-6 text-center">
                <h2 class="orb-app-light-dark:font-bold mb-4 text-lg font-semibold">
                    {{ 'JOURNEY_TICKET_PURCHASE_WARNING_MODAL_TITLE' | translate }}
                </h2>

                <p class="orb-app-light-dark:mb-0 mb-6 leading-relaxed">
                    {{ data?.message }}
                </p>
            </div>

            <div class="m-4">
                <ng-container *ngIf="data?.type === 'warning'">
                    <button
                        class="flex-align-center sr-app-light:text-primary vl-app-light:text-primary mb-2 flex h-14 w-full justify-center gap-2 rounded-lg bg-transparent font-bold text-secondary dark:text-contrast-yellow"
                        [attr.aria-label]="'CANCEL' | translate"
                        (click)="closeModal()">
                        {{ 'CANCEL' | translate }}
                    </button>

                    <button
                        class="orb-app-light:bg-primary orb-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        [attr.aria-label]="'BUY_TICKET' | translate"
                        (click)="confirmPurchase()">
                        {{ 'BUY_TICKET' | translate }}
                    </button>
                </ng-container>

                <ng-container *ngIf="data?.type === 'error'">
                    <button
                        class="orb-app-light:bg-primary orb-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        [attr.aria-label]="'CLOSE' | translate"
                        (click)="closeModal()">
                        {{ 'CLOSE' | translate }}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
